/*通用vuex存储*/
const moudule_common = {
  namespaced:true,
  state:{
    cur_func:'',/*选中功能*/

    cur_tool:'',/*选择工具*/


    cur_screen_name:'驾驶舱',/*当前首页名称*/
    user_management:'用户管理',/*当前首页名称*/
    cur_qhdm:'',/*当前所选行政区划代码*/
    cur_qhmc:'',/*当前所选行政区划名称*/

    cur_view_mode:'二维',/*地图模式*/

    /*=======图层树用==========*/

    layer_tree_l1_content:[],/*所有图层树节点信息*/
    layer_tree_model:[],/*图层树控制的模型信息*/
    layer_tree_model_id:[],/*图层树控制的模型id*/
    sys_layer_info:[],/*图层树结构中，所有图层节点数组*/
    sys_multi_layer_info:[],/*记录单节点控制多图层数据的情况，子节点对应父节点*/
    sys_multi_layer_info2:[],/*记录单节点控制多图层数据的情况,父节点对应子节点*/
    sys_layer_tree_data:[],/*图层树结构*/
    model_info_node:{},/*模型节点信息*/
    tree_node_info:[],/*所有数据和混合节点*/

    /*=======图层树用==========*/
    _2D_roller:false,/*二维卷帘*/
  },

  getters:{



    get_user_management: state => {
      return state.user_management
    },
    get_cur_screen_name: state => {
      return state.cur_screen_name
    },

    get_2D_roller: state => {
      return state._2D_roller
    },


    get_cur_dk_query_func: state => {
      return state.cur_dk_query_func
    },


    get_cur_func: state => {
      return state.cur_func
    },

    get_cur_tool: state => {
      return state.cur_tool
    },

    get_cur_qhdm: state => {
      return state.cur_qhdm
    },

    get_cur_qhmc: state => {
      return state.cur_qhmc
    },

    get_cur_view_mode: state => {
      return state.cur_view_mode
    },

    /*=======图层树用==========*/


    get_layer_tree_l1_content:state => {
      return state.layer_tree_l1_content
    },

    get_layer_tree_model:state => {
      return state.layer_tree_model
    },

    get_layer_tree_model_id:state => {
      return state.layer_tree_model_id
    },

    get_sys_layer_info:state => {
      return state.sys_layer_info
    },

    get_sys_multi_layer_info:state => {
      return state.sys_multi_layer_info
    },

    get_sys_multi_layer_info2:state => {
      return state.sys_multi_layer_info2
    },

    get_sys_layer_tree_data:state => {
      return state.sys_layer_tree_data
    },

    get_model_info_node:state => {
      return state.model_info_node
    },

    get_tree_node_info:state => {
      return state.tree_node_info
    },
    /*=======图层树用==========*/
  },

  mutations:{


    set_user_management: (state,user_management) => {
      state.user_management = user_management
    },

    set_cur_screen_name: (state,cur_screen_name) => {
      state.cur_screen_name = cur_screen_name
    },

    set_2D_roller: (state,val) => {
      state._2D_roller = val
    },

    set_cur_func: (state,cur_func) => {
      state.cur_func = cur_func
    },

    set_cur_dk_query_func: (state,cur_dk_query_func) => {
      state.cur_dk_query_func = cur_dk_query_func
    },

    set_cur_tool:(state,cur_tool) =>{
      state.cur_tool = cur_tool
    },

    set_cur_qhdm: (state,cur_qhdm) => {
      state.cur_qhdm = cur_qhdm
    },

    set_cur_qhmc: (state,cur_qhmc) => {
      state.cur_qhmc = cur_qhmc
    },

    set_cur_view_mode:(state,cur_view_mode) => {
      state.cur_view_mode = cur_view_mode
    },

    /*=======图层树用==========*/
    set_layer_tree_l1_content:(state,status) =>{
      state.layer_tree_l1_content = status
    },

    set_layer_tree_model:(state,status) =>{
      state.layer_tree_model = status
    },

    set_layer_tree_model_id:(state,status) =>{
      state.layer_tree_model_id = status
    },

    set_sys_layer_info:(state,status) =>{
      state.sys_layer_info = status
    },

    set_sys_multi_layer_info:(state,status) =>{
      state.sys_multi_layer_info = status
    },

    set_sys_multi_layer_info2:(state,status) =>{
      state.sys_multi_layer_info2 = status
    },

    set_sys_layer_tree_data:(state,status) =>{
      state.sys_layer_tree_data = status
    },

    set_model_info_node:(state,status) =>{
      state.model_info_node = status
    },

    set_tree_node_info:(state,status) =>{
      state.tree_node_info = status
    },
    /*=======图层树用==========*/
  },

  actions:{

  }

}

export default moudule_common



// WEBPACK FOOTER //
// ./src/store/modules/sys_common_store.js